import React from 'react';
/** Original Bitnex Freight LLC mark: interlocking B and F with a forward-route motif. */
export function LogoMark({ size = 40, className = '' }) {
  return <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} role="img" aria-label="Bitnex Freight LLC emblem">
    <rect x="2" y="2" width="60" height="60" rx="17" fill="#0D2925"/>
    <path d="M17 16 V49 H32 C43 49 44 35 33 33 C42 29 41 17 29 16 Z" stroke="#5BD7BD" strokeWidth="5" strokeLinejoin="round" />
    <path d="M25 25 H33 M25 40 H34" stroke="#5BD7BD" strokeWidth="4" strokeLinecap="round"/>
    <path d="M43 17 V47 M43 17 H54 M43 31 H52" stroke="#D47D53" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>;
}
export default function Logo({ inverse = false, className = '', markSize = 43 }) {
  return <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark size={markSize} />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-[1.35rem] sm:text-[1.65rem] font-extrabold tracking-[0.015em] ${inverse ? 'text-white' : 'text-navy-900'}`}>BITNEX<span className="text-gold-300"> FREIGHT</span><span className="ml-1 text-[0.7rem] sm:text-[0.8rem] tracking-normal">LLC</span></span>
      <span className={`mt-1 text-[0.58rem] font-bold uppercase tracking-[0.33em] ${inverse ? 'text-navy-200' : 'text-ink-500'}`}>TRAILER RENTALS</span>
    </span>
  </span>;
}
